import Keyb from "keyb"
import Pointer from "poin"
import Joyp from "joyp"

import Sequence from "@frog/source/models/Sequence.js"

import Stage from "@frog/source/models/Stage.js"
import Selection from "@frog/source/models/admin/Selection.js"
import Zone from "@frog/source/models/Zone.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Director from "@frog/source/juice/Director.js"
import Geometry from "@frog/source/utility/Geometry.js"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import InkDialogue from "@frog/source/utility/integration/InkDialogue.js"
import getLevelStatus from "@frog/source/models/logic/getLevelStatus.js"
import Random from "@frog/source/utility/Random.js"
import games from "@frog/source/data/games/index.js"

export default class CombatChapter {
    static load(proto) {
        const chapter = new CombatChapter()
        chapter.type = "combat"
        chapter.player = proto.player || {"affiliation": "good"}
        chapter.slug = proto.chapter.slug
        chapter.gameslug = proto.gameslug
        chapter.images = proto.chapter.images
        chapter.audio = proto.chapter.audio
        chapter.hasTutorial = proto.chapter.hasTutorial
        chapter.hasPreparePhase = proto.chapter.hasPreparePhase
        chapter.hasUndoEndTurnButtons = proto.chapter.hasUndoEndTurnButtons
        chapter.isRandomized = proto.chapter.isRandomized

        chapter.decorations = proto.chapter.decorations || {}

        if(chapter.audio != undefined) {
            if(chapter.audio instanceof Array != true) {
                Audiomix.trigger(chapter.audio)
            } else {
                chapter.audio.forEach((audio) => {
                    Audiomix.trigger(audio)
                })
            }
        }

        chapter.encounters = proto.chapter.encounters

        // chapter.events = proto.chapter.events

        chapter.stage = Stage.load({
            "stage": proto.chapter.stage,
            "player": proto.player,
            "chapterParty": proto.chapterParty,
            "hasPreparePhase": chapter.hasPreparePhase,
            "startingEncounter": proto.chapter.startingEncounter,
        })
        if(proto.chapter.stage != undefined) {
            Dev.loadedProtostage = proto.chapter.stage
        }
        // let that = chapter
        // for(let key in that) {
        //     this[key] = that[key]
        // }

        chapter.previousStages = []


        chapter.sequence = {
            "steps": []
                // .concat(Stage.getEventSteps(chapter.stage, "turn:0:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every-even:start"))
        }
        if(chapter.sequence.steps != undefined
        && chapter.sequence.steps.length > 0) {
            chapter.stage = chapter.sequence.steps[chapter.sequence.steps.length - 1].omegastage
        }

        if(chapter.hasPreparePhase == true) {
            chapter.startPreparePhase()
        } else {
            chapter.startPlayPhase()
        }

        chapter.selection = new Selection({"chapter": chapter})

        return chapter
    }
    startPreparePhase() {
        this.phase = "prepare"
    }
    startPlayPhase({dialogue} = {}) {
        this.phase = "play"

        const events = []
            .concat(Stage.getEventSteps(this.stage, "chapter:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:0:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every-even:start"))
        const steps = Stage.processEventSteps(this.stage, events)

        if(steps.length > 0) {
            this.stage = steps[steps.length-1].omegastage
            Stage.calculateActions(this.stage)
            this.sequence = {"steps": steps}
        }

        Stage.calculateActions(this.stage)
    }
    update(delta) {
        this.selection.update(delta)

        if(Dev.inProtoMode == false) {
            if(Keyb.wasJustPressed("Z")
            || Joyp.wasJustPressed(0, "left-bumper", delta.ms)
            || Joyp.wasJustPressed(0, "right-bumper", delta.ms)) {
                this.undoAction()
            }
        }

        if(Keyb.isPressed("<control>") && Keyb.isPressed("R")) {
            App.game.chapter.restart()
        }

        if(Dev.inProtoMode == false
        && this.stage != undefined) {
            if(Pointer.wasJustPressed("primary", true, delta.ms)
            || Keyb.wasJustPressed("<space>", delta.ms)
            || Joyp.wasJustPressed(0, "south-button", delta.ms)) {
                if(this.sequence != undefined) {
                    Sequence.seek(this.sequence)
                }
            }
            if(Keyb.wasJustPressed("<enter>")) {
                this.sequence = undefined
            }
            Director.updateSequence({
                "sequence": this.sequence,
                "delta": delta,
            })
        }
    }
    setStage(stage) {
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    reloadStage(stage) {
        let protogame = games[this.gameslug]
        let protochapter = protogame.chapters[this.slug]
        this.stage = Stage.load({
            "stage": protochapter.stage,
            "player": protogame.player,
            "chapterParty": protogame.chapterParty,
            "hasPreparePhase": protochapter.hasPreparePhase,
            "startingEncounter": structuredClone(this.stage.currentEncounter),
        })
        this.recalculateStage()
    }
    killAllEnemies() {
        this.saveStage()
        let currentZone = this.stage.encounters[this.stage.currentEncounter]
        Object.values(this.stage.units).map((unit) => {
            if(Zone.isInBounds(currentZone, unit.position)) {
                if(unit.affiliation == "bad" || unit.jobKey == "door") {
                    unit.health = 0
                }
            }
        })
        this.recalculateStage()
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            this.stage = this.previousStages.pop()

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.frog != undefined
            && window.frog.test != undefined
            && window.frog.test.snapshot != undefined) {
                window.frog.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            // if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
            //     this.selection.reset()
            // }
            this.selection.reset()

            this.sequence = undefined
        }
    }
    performAction(action) {
        // if(window.frog != undefined
        // && window.frog.test != undefined
        // && window.frog.test.snapshot != undefined) {
        //     window.frog.test.snapshot.protoactions.push({
        //         "unitKey": action.performerKey,
        //         "position": Geometry.copy(action.position),
        //         "actionKey": action.key,
        //     })
        // }

        App.game.chapter.sequence = {"steps": action.steps}
        // action.omegastage.steps = steps
        Stage.calculateActions(action.omegastage)
        this.setStage(action.omegastage)

        // Auto-finishing
        if(this.hasAutoEnd === true
        || this.hasUndoEndTurnButtons === false) {
            const hasFinishedTurn = Object.values(action.omegastage.units).filter((unit) => {
                if(unit.affiliation != App.game.chapter.stage.player.affiliation) return false
                if(unit.isDead == true) return false
                if(unit.hasBeenRemoved == true) return false
                if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone, unit.position)) return false
                if(unit.subclasses != undefined) {
                    return unit.energy[1] != false
                        || unit.energy[2] != false
                } else {
                    return unit.energy[1] != false
                }

            }).length == 0
            if(hasFinishedTurn == true) {
                return this.endPlayerTurn(action.omegastage)
            }
        }

        return action.omegastage
    }
    saveStage() {
        const omegastage = Stage.copy(this.stage)
        omegastage.steps = []
        this.setStage(omegastage)
    }
    recalculateStage() {
        Stage.calculateActions(this.stage, {"force": true})
    }
    endPlayerTurn(stage) {
        stage = stage || this.stage

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()

        // And now.. perform the next turn!!

        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }



        const steps = stage.nextTurn.steps
        App.game.chapter.sequence = {"steps": steps}

        const omegastage = steps[steps.length-1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)
        this.clearPreviousStages()

        return omegastage
    }
    restart() {
        App.load({
            "game": {
                "slug": this.gameslug,
                "player": App.game.player,
                "chapter": games[this.gameslug].chapters[App.game.chapter.slug],
                "configuration": games[this.gameslug].configuration,
            }
        })
    }
}
